export const reservedWords = [
  'admin',
  'mate',
  'apply',
  'root',
  'peach',
  'meet',
  'meetmy',
  'login',
  'logout',
  'tutor',
  'tutors',
  'payment',
  'error',
  'page',
  'terms',
  'privacy',
  'squad',
  'legal',
  // Root routes: `[tutor]` is a bare dynamic segment at the app root, so a
  // static route always wins and a provider who claimed one of these would get
  // an unreachable storefront. Adding a root route means adding it here.
  'connections',
  'dashboard',
  'post',
  'replies',
  'reply',
  'agent',
  'trend',
  // The connector for Claude and ChatGPT: `/mcp`, the consent page under `/oauth`, its help at
  // `/connect`, its pages at `/claude` and `/chatgpt`, and the Signal builder and console.
  'mcp',
  'oauth',
  'connect',
  'claude',
  'chatgpt',
  'new',
  'home',
  // The creator's three pages (PRINCIPLES.md § 3), reserved before they all exist.
  'funnel',
  'client',
  'clients',
  'funnels',
  'people',
  'calls',
  'media',
  'student',
  'students',
  'creator',
  'creators',
  'hello',
  'share',
  'bookings',
  'balance',
  'call',
  'offer',
  'invoice',
  'invite',
  'careers',
  'blog',
  'about',
  'help',
  'docs',
  'status',
  'report',
  'quiz',
  'create',
  'kit',
  'support',
  'coach',
  'coaches',
  'trainer',
  'trainers',
  'mentor',
  'mentors',
  'teacher',
  'teachers',
  'instructor',
  'instructors',
  'expert',
  'experts',
  'consultant',
  'consultants',
  'specialist',
  'specialists',
  'psychologist',
  'psychologists',
  'therapist',
  'therapists',
];
